import { rest, setupWorker } from 'msw'

import { PIX_KEY } from '@/common/constants/endpoints'
import * as MOCKS from '@/common/mocks/responses'

const DEFAULT_DELAY = 5000
const SUCCESS_STATUS = 200

export const EndPoints = [
  rest.post(PIX_KEY, (_request, response, context) =>
    response(context.delay(DEFAULT_DELAY), context.status(SUCCESS_STATUS), context.json(MOCKS.PIX)),
  ),
]

export const worker = () => setupWorker(...EndPoints)
